export default {
  login: '登录',
  logout: '退出登录',
  username: '用户名',
  password: '密码',
  rememberMe: '记住我',
  forgotPassword: '忘记密码？',
  loginSuccess: '登录成功',
  loginFailed: '登录失败',
  unauthorized: '未授权，请重新登录',
  forbidden: '权限不足',
};
